module.exports = __webpack_public_path__ + "img/inserter-1.689098b3.png";